import React, { Fragment, useState } from "react";
import Chip from "@material-ui/core/Chip";
import get from "lodash/get";
import { find } from "lodash";
import {
  busScheduleStatusList,
  formTypeList,
  invoiceStatusList,
  statusList,
} from "pages/changeRequestForms/conts";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  makeStyles,
} from "@material-ui/core";
import { SimpleForm, Button, SelectInput, required } from "react-admin";
import UpdateStatusButton from "./UpdateStatusButton";

interface ICustomTypeField {
  label?: string;
  record?: any;
  source: string;
  type: string;
}

const useStyles = makeStyles({
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
  form: {
    "& .MuiCardContent-root": {
      padding: 0,
    },
  },
});

const getTypeList = (type: string) => {
  switch (type) {
    case "changeRequest_FormType":
      return formTypeList;
    case "changeRequest_busSchedule":
      return busScheduleStatusList;
    case "changeRequest_invoice":
      return invoiceStatusList;
    case "changeRequest_status":
      return statusList;
    default:
      return;
  }
};

export const translateText = (text: string, type: string): string => {
  if (text) {
    const types = getTypeList(type);
    const findText = find(types, ["id", text]);

    return findText.name.toUpperCase();
  }
  // make capital to all type
};

const getColor = (text: string, type: string): string => {
  if (text) {
    const types = getTypeList(type);
    const findText = find(types, ["id", text]);

    return findText?.color;
  }
};

const CustomTypeField = ({
  label,
  record = {},
  source,
  type,
}: ICustomTypeField) => {
  const classes = useStyles();

  const text = get(record, source);
  const translated = translateText(text, type);
  const color = getColor(text, type);

  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <Chip
        label={translated}
        style={{ backgroundColor: `${color}`, color: "#FFF" }}
        onClick={handleOpen}
      />

      <SimpleForm
        toolbar={null}
        initialValues={record}
        className={classes.form}
      >
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className={classes.dialog}
          fullWidth
          maxWidth="xs"
        >
          <DialogTitle id="alert-dialog-title">
            Change {label} #{record.id}
          </DialogTitle>
          <DialogContent dividers>
            <SelectInput
              label={label}
              choices={getTypeList(type)}
              source={source}
              validate={required()}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="secondary" label="Back" />
            <UpdateStatusButton />
          </DialogActions>
        </Dialog>
      </SimpleForm>
    </Fragment>
  );
};

export default CustomTypeField;
